import { render, staticRenderFns } from "./ColorCalibrationReport.vue?vue&type=template&id=16874699&scoped=true&"
import script from "./ColorCalibrationReport.vue?vue&type=script&lang=js&"
export * from "./ColorCalibrationReport.vue?vue&type=script&lang=js&"
import style0 from "./ColorCalibrationReport.vue?vue&type=style&index=0&id=16874699&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16874699",
  null
  
)

export default component.exports